import React from "react";
import { Link } from "react-router-dom";
import IntroVideo from '../../videos/Axis_background.mp4';
import VideoComponent from '../VideoComponent.js';
import Axis_Logo from '../../images/Axis_image6.png';
import PageSEO from "../../components/seo/PageSEO";
import { useScrollBehavior } from '../useScrollBehavior.js';
import { BLOG_POSTS } from "./blogData";
import "../../styles/home.css";
import "../../styles/blog.css";

export default function BlogIndex() {
  useScrollBehavior();

  return (
    <main className="home">
      <PageSEO
        title="Blog | The Axis"
        description="Philosophy, mission, and commentary from the Axis."
        path="/blog"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          "name": "The Axis Blog",
          "url": (process.env.REACT_APP_SITE_URL || "") + "/blog"
        }}
      />

      <div className="home__bg" aria-hidden="true">
        <VideoComponent videoSrc={IntroVideo} />
      </div>

      <section className="home__content">

        {/* ── HEADER ── */}
        <div className="module blog-index__header">
          <div className='home__logo '>
            <img src={Axis_Logo} alt="Axis_logo" className="axis_logo" />
          </div>
          <span className="about__eyebrow">The Axis</span>
          <h1 className="home__title">Blog</h1>
          <p className="home__subtitle">Philosophy • Mission • Commentary</p>
          <p className="home__copy">
            Writing from the Axis — on the Sacred Three, the state of the world,
            and what principled people are prepared to do about it.
          </p>
        </div>

        {/* ── POSTS ── */}
        <div className="module blog-index__grid-module">
          <div className="blog-index__grid">
            {BLOG_POSTS.map((post) => (
              <article key={post.slug} className="blog-card">

                {/* Image slot */}
                {post.image ? (
                  <div className="blog-card__image">
                    <img src={post.image} alt={post.title} />
                  </div>
                ) : (
                  <div className="blog-card__image blog-card__image--placeholder" aria-hidden="true" />
                )}

                <div className="blog-card__body">
                  <div className="blog-card__meta">
                    {post.category && (
                      <span className="blog-card__category">{post.category}</span>
                    )}
                    <span className="blog-card__date">{post.date}</span>
                  </div>

                  <h2 className="blog-card__title">{post.title}</h2>
                  <p className="blog-card__excerpt">{post.excerpt}</p>

                  {post.author && (
                    <p className="blog-card__author">— {post.author}</p>
                  )}

                  <div className="blog-card__actions">
                    <Link className="btn btn--primary" to={`/blog/${post.slug}`}>
                      Read
                    </Link>
                  </div>
                </div>

              </article>
            ))}
          </div>
        </div>

      </section>
    </main>
  );
}



/*import React from "react";
import { Link } from "react-router-dom";
import PageSEO from "../../components/seo/PageSEO";
import "../../styles/blog.css";
import { BLOG_POSTS } from "./blogData";
import { useScrollBehavior } from '../useScrollBehavior.js'; 

export default function BlogIndex() {

  useScrollBehavior();

  return (
    <main className="page">
      <PageSEO
        title="Blog | Your App Name"
        description="Updates, announcements, and deep dives."
        path="/blog"
      />

      <header className="pageHeader">
        <h1>Blog</h1>
        <p>Updates, announcements, and deep dives.</p>
      </header>

      <section className="blogGrid">
        {BLOG_POSTS.map((post) => (
          <article key={post.slug} className="blogCard">
            <div className="blogCard__meta">
              <div className="blogCard__date">{post.date}</div>
            </div>
            <h2 className="blogCard__title">{post.title}</h2>
            <p className="blogCard__excerpt">{post.excerpt}</p>
            <div className="blogCard__actions">
              <Link className="btn btn--primary" to={`/blog/${post.slug}`}>Read</Link>
              <Link className="btn btn--ghost" to="/app">Get the App</Link>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}*/
